<template>
  <v-list two-line subheader v-if="!loadingRequest">
    <v-list-tile v-for="(card, index) in userMP.cards" :key="index" avatar>
      <v-list-tile-content>
        <v-list-tile-title>
          <img :src="card.payment_method.secure_thumbnail" :alt="card.issuer.name">
        </v-list-tile-title>
        <v-list-tile-sub-title>final {{ card.last_four_digits }}</v-list-tile-sub-title>
      </v-list-tile-content>

      <v-list-tile-action>
        <v-list-tile-action-text v-if="userMP.default_card === card.id">Principal</v-list-tile-action-text>
        <a flat v-else @click="turnDefaultCard(card)">
          <small>tornar principal</small>
        </a>
        <v-btn icon ripple v-if="userMP.default_card != card.id" @click="deleteCard(card)">
          <v-icon color="grey lighten-1" small>fal fa-trash-alt</v-icon>
        </v-btn>
      </v-list-tile-action>
    </v-list-tile>
  </v-list>
</template>

<script>
import axios from 'axios'
import EventBus from '@/event-bus'

export default {
  props: ['userMP'],

  data: () => ({
    loadingRequest: false
  }),

  methods: {
    deleteCard (item, confirmUnRequired) {
      this.loadingRequest = true
      // const path = `${API.mpCustomersCards}/${this.userMP.id}/cards/${item.id}`
      const path = `${API.mpCustomersCards}/${item.id}/customers/${this.userMP.id}`
      const index = this.userMP.cards.indexOf(item)

      if (!confirmUnRequired) {
        this.loadingRequest = false
        confirm(`Tem certeza que deseja apagar cartão final "${item.last_four_digits}" ?`) && this.deleteCard(item, true)
        return
      }

      axios.delete(path).then(response => {
        this.loadingRequest = false
        EventBus.$emit('loadUserOnMP')
        EventBus.$emit('showSnackbar', { message: 'Cartão apagado com sucesso!', color: 'success' })
        this.userMP.splice(index, 1)
      }).catch(errors => {
        this.loadingRequest = false
        EventBus.$emit('showSnackbar', { message: errors.response.data.message, color: 'error' })
      })
    },

    turnDefaultCard (card) {
      this.loadingRequest = true
      const path = `${API.mpCustomers}/${this.userMP.id}`

      const params = {
        default_card: card.id
      }

      axios.put(path, params).then(response => {
        this.loadingRequest = false
        EventBus.$emit('showSnackbar', { message: 'Alteração feita com sucesso!', color: 'success' })
        this.userMP.default_card = card.id
      }).catch(errors => {
        this.loadingRequest = false
        EventBus.$emit('showSnackbar', { message: errors.response.data.message, color: 'error' })
      })
    }
  }
}
</script>

<style scoped>
.v-list__tile {
  background: #f0f0f0;
}
</style>



// WEBPACK FOOTER //
// src/components/user/financial/UserFinancialCardsList.vue